import { PATH_TO_VIEWER } from './common';

export function createPDFFileUrl(url: string) {
  return `${PATH_TO_VIEWER}?file=${url}`;
}
